import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../utils/api';
import Loader from '../../components/common/Loader';
import '../../styles/Forms.css';

const AddLocationPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = !!id;

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    isActive: true,
  });

  useEffect(() => {
    if (isEdit) {
      fetchLocation();
    }
  }, [id]);

  const fetchLocation = async () => {
    try {
      setLoading(true);
      const res = await api.getLocation(id);
      if (res.success && res.data) {
        const location = res.data;
        setFormData({
          name: location.name || '',
          description: location.description || '',
          isActive: location.isActive !== undefined ? location.isActive : true,
        });
      } else {
        toast.error('Location not found');
        navigate('/admin/locations');
      }
    } catch (error) {
      console.error('Error loading location:', error);
      toast.error('Error loading location details');
      navigate('/admin/locations');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      toast.error('Please enter location name');
      return;
    }

    try {
      setLoading(true);

      const payload = {
        name: formData.name.trim(),
        description: formData.description.trim() || undefined,
        isActive: formData.isActive,
      };

      let res;
      if (isEdit) {
        res = await api.updateLocation(id, payload);
      } else {
        res = await api.createLocation(payload);
      }

      if (res.success) {
        toast.success(isEdit ? 'Location updated successfully!' : 'Location created successfully!');
        navigate(-1);
      } else {
        toast.error(
          (isEdit ? 'Error updating location: ' : 'Error creating location: ') +
            (res.message || 'Unknown error')
        );
      }
    } catch (error) {
      console.error(isEdit ? 'Error updating location:' : 'Error creating location:', error);
      toast.error(
        (isEdit ? 'Error updating location: ' : 'Error creating location: ') +
          (error.message || 'Unknown error')
      );
    } finally {
      setLoading(false);
    }
  };

  if (loading && isEdit) {
    return <Loader />;
  }

  return (
    <div className="add-location-page" style={{ padding: '16px', display: 'flex', justifyContent: 'center' }}>
      <div
        style={{
          background: 'white',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          maxWidth: '600px',
          width: '100%',
        }}
      >
        <h2 style={{ margin: '0 0 20px 0', fontSize: '18px', fontWeight: 600 }}>
          {isEdit ? 'Edit Location' : 'Add New Location'}
        </h2>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">
              Location Name <span style={{ color: '#e53e3e' }}>*</span>
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              rows="4"
            />
          </div>

          <div style={{ marginBottom: '12px', display: 'flex', alignItems: 'center' }}>
            <input
              id="isActive"
              name="isActive"
              type="checkbox"
              checked={formData.isActive}
              onChange={handleInputChange}
              style={{ marginRight: '6px' }}
            />
            <label htmlFor="isActive" style={{ margin: 0, fontSize: '13px', color: '#4a5568' }}>
              Active
            </label>
          </div>

          <div style={{ display: 'flex', gap: '10px', marginTop: '20px', justifyContent: 'flex-end' }}>
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="btn-secondary"
            >
              Cancel
            </button>
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Saving...' : isEdit ? 'Update Location' : 'Create Location'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddLocationPage;

